<template>
  <section id="demo" class="grey lighten-3">
    <v-container class="text-center px-0 py-0">

      <div class="py-12"></div>
      <v-expand-transition>
        <div v-show="expand">
          <h2 class="display-2 font-weight-bold mb-3">Try out SubVox with your own images</h2>

          <v-responsive class="mx-auto mb-12" width="56" >
            <v-divider class="mb-1"></v-divider>
            <v-divider></v-divider>
          </v-responsive>

          <div v-show="!showResult" outlined class="ma-8 d-flex justify-space-around">
            <v-spacer />
            <image-selector :label="'Image 1'" ref="image1" @imageSelected="imageSelected" />
            <image-selector :label="'Image 2'" ref="image2" @imageSelected="imageSelected" />
            <v-spacer />
          </div>

          <div v-if="statusMessage">{{ statusMessage }} </div>

          <img v-show="showResult" :src="resultImage" contain />

          <v-spacer />
          <div class="py-6 px-6" v-if="taskProgress >= 0">
            <v-progress-linear
                v-if="showProgress"
                v-model="taskProgress"
                height="25"
            >
              <strong>{{ Math.ceil(taskProgress) }}%</strong>
            </v-progress-linear>
          </div>

          <v-spacer />

          <v-btn v-if="resultCSV" tile color="primary" outlined :href="resultCSV">
            <v-icon>mdi-download</v-icon>CSV
          </v-btn>

        </div>
      </v-expand-transition>

      <div class="py-6 px-6"><v-btn color="info" x-large block class="py-12 px-12" elevation=8 @click="buttonClicked()" :disabled="buttonDisabled">{{ buttonLabel}}</v-btn></div>

    </v-container>
  </section>
</template>


<script>

import ImageSelector from './ImageSelector';

export default {
  name: 'DemoBlock',
  components: {
    'image-selector': ImageSelector,
  },
  data: () => ({
    buttonDisabled: false,
    expand: false,
    state: 'waiting for images',
    buttonLabel: "TRY IT OUT",
    job_id: null,
    resultImage: null,
    resultCSV: null,
    showResult: false,
    jobCheckPeriod: 500,
    jobTimer: 0,
    maxJobCheckTime: 20000,
    statusMessage: '',
    showProgress: true,
    taskProgress: -1,
  }),
  methods: {
    buttonClicked() {
      if (this.expand == false) {
        this.expand = true;
        this.buttonDisabled = true;
        this.buttonLabel = "Select Images..."
        this.$http.get(this.getHost() + 'ev/try_demo')
        this.$http
            .get(this.getHost() + 'job')
            .then(function(data) {
              console.log(data);
              if (data.body['job_id'] != undefined) {
                this.job_id = data.body['job_id']
                this.resultImage = this.getHost() + 'job/' + this.job_id + '/vectors.png';
                this.resultCSV = this.getHost() + 'job/' + this.job_id + '/vectors.csv';
                this.$refs.image1.imageUrl = this.getHost() + 'job/' + this.job_id + '/thumb1.jpg';
                this.$refs.image1.preview = true;
                this.$refs.image2.imageUrl = this.getHost() + 'job/' + this.job_id + '/thumb2.jpg';
                this.$refs.image2.preview = true;
                this.showResult = true;
                this.setState('completed');
              }
            });


      } else if (this.buttonLabel == "Cancel Job") {
        this.$http
            .get(this.getHost() + 'job/' + this.job_id + "/cancel")
            .then(function(data) {
              console.log(data);
              this.showMessage("Status: " + data.body['status'])
              this.setState('completed');
            });
      } else if (this.$refs.image1.loaded && this.$refs.image2.loaded) {
        this.submitImages();
      }
    },
    imageSelected() {
      this.statusMessage = '';
      if (this.$refs.image1.loaded && this.$refs.image2.loaded) {
        this.buttonDisabled = false;
        this.buttonLabel = "UPLOAD & PROCESS";
        this.setState("ready to submit");
      }
    },
    submitImages() {
      console.log("Submit Images");

      this.resultImage = null;
      this.resultCSV = null;

      this.buttonLabel = "Cancel Job"

      let formData = new FormData();
      formData.append('image1', this.$refs.image1.imageFile);
      formData.append('image2', this.$refs.image2.imageFile);

      this.jobTimer = 0;

      this.statusMessage = "Uploading images ...";
      this.showProgress = true;
      this.taskProgress = 0;

      this.$http
          .post(this.getHost() + 'job', formData, {
            progress: function (progressEvent) {
              let p = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
              this.taskProgress = p;
            }.bind(this)
          })
          .then(function(data) {
            if (data.body.status == 'error') {
              this.statusMessage = "Error: " + data.body.error_msg;
              this.showMessage("Error: " + data.body.error_msg);
              this.setState('completed');
            } else {
              this.job_id = data.body.job_id;
              this.checkForResult();
            }
          });

      this.setState('submitted');
    },
    setProgressValue(progress) {
      this.taskProgress = progress;
    },
    checkForResult() {
      this.$http
          .get(this.getHost() + 'job/' + this.job_id)
          .then(function(data) {
            let meta = data.body['meta'];
            this.jobTimer += this.jobCheckPeriod;
            if (data.body.status == 'error') {
              this.statusMessage = 'Error: ' + data.body.error_msg
              this.showMessage("Error: " + data.body.error_msg);
              this.setState('completed');
            }
            else if (data.body.status == 'finished') {
              this.statusMessage = ''
              this.taskProgress = -1;
              this.progressmessage = "Success"
              this.loadResults();
              this.setState('completed');
            }
            else if (data.body.status == 'failed') {
              this.taskProgress = -1;
              this.statusMessage = 'Sorry the job Failed. Our developers will look into this.'
              this.showMessage("Job " + this.job_id + " FAILED!!!!");
              this.setState('completed');
            }
            else {
              if (this.jobTimer > this.maxJobCheckTime) {
                this.statusMessage = "Sorry the job took too long. Our developers will look into this."
                this.showMessage("Job " + this.job_id + " timed out")
                this.setState('completed');
              } else {

                if (meta != undefined && meta['progress'] != undefined) {
                  if (data.body.has_thumbnails) {
                    if (!this.$refs.image1.formatSupported) {
                      this.$refs.image1.imageUrl = this.getHost() + 'job/' + this.job_id + '/thumb1.png';
                      this.$refs.image1.formatSupported = true;
                    }
                    if (!this.$refs.image2.formatSupported) {
                      this.$refs.image2.imageUrl = this.getHost() + 'job/' + this.job_id + '/thumb2.png';
                      this.$refs.image2.formatSupported = true;
                    }
                  }
                  let progressPercent = parseInt(meta['progress']);
                  if (meta['status'] != undefined) {
                    this.statusMessage = meta['status'];
                  } else {
                    this.statusMessage = 'Processing...';
                  }
                  if (this.taskProgress != progressPercent) {
                    this.jobTimer = 0;
                  }
                  this.showProgress = true;
                  this.taskProgress = progressPercent;
                }
                setTimeout(() => this.checkForResult(), this.jobCheckPeriod);
              }
            }
            // job_id = data
          });
    },
    loadResults() {
      console.log("Loading job results");
      this.resultImage = this.getHost() + 'job/' + this.job_id + '/vectors.png';
      this.resultCSV = this.getHost() + 'job/' + this.job_id + '/vectors.csv';
      this.showResult = true;
      this.setState('completed');
    },
    activate() {
      setTimeout(() => this.checkForResult(), 1000);
    },
    setState(state) {
      this.state = state;
      if (state == 'waiting for images') {
        this.buttonDisabled = true;
        this.buttonLabel = 'Select Images';
      }
      else if (state == 'ready to submit') {
        this.buttonLabel = 'Submit Job';
      }
      else if (state == 'submitted') {
        this.buttonDisabled = true;
        this.buttonLabel = 'Processing...';
      }
      else if (state == 'completed') {
        this.buttonDisabled = false;
        this.buttonLabel = 'Try Again'
      }

    },
    showMessage(msg) {
      console.log(msg);
    }
  }
}
</script>
